import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    width: '100vw',
  },
  list: {
    margin: 0,
    padding: '20px 20px 90px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'auto',
    gridGap: '15px',
  },
  item: {
    margin: 0,
    listStyle: 'none',
    background: '#002C70',
    borderRadius: '10px',
    color: '#fff',
    fontWeight: 400,
    fontFamily: 'Montserrat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    fontSize: '1rem',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    boxSizing: 'border-box',
    padding: '10px',
    minHeight: '80px',
    textAlign: 'center',
  },
  footer: {
    boxShadow: '0px -1px 6px rgba(0, 0, 0, 0.25)',
    padding: '20px',
    background: '#fff',
    width: '100vw',
    position: 'fixed',
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& h1': {
      padding: 0,
      fontWeight: 500,
      color: '#FF7A01',
      fontFamily: 'Montserrat',
      fontSize: '1rem',
      textTransform: 'uppercase',
    },

    '& svg': {
      color: '#FF7A01',
    },
  },
  cart: {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
  },
});

export default useStyles;
